export const API_URL = "https://physics-calc-api-cp.vercel.app/api";
